import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TrainingTreeNode } from '../models/training-tree-node';
import { ToastMessageService } from '../../shared/services/toast-message.service';

@Injectable({
    providedIn: 'root',
})
export class JobService {
    private readonly baseUrl: string;

    constructor(
        private http: HttpClient,
        private toastMessageService: ToastMessageService
    ) {
        this.baseUrl = `${environment.backendUrl}/rest/job`;
    }

    start(
        trainingNode: TrainingTreeNode,
        ignoreGradeHint: boolean
    ): Observable<void> {
        const url = `${this.baseUrl}/${trainingNode.uuid}`;
        const params = { ignoreGradeHint: ignoreGradeHint };

        return this.http.post<void>(url, undefined, { params }).pipe(
            catchError((error) => {
                this.toastMessageService.showTranslatedErrorMsg(
                    'splitScreen.components.contextMenu.notStarted',
                    { name: trainingNode.name }
                );
                return throwError(() => error);
            }),
            tap(() => {
                this.toastMessageService.showTranslatedSuccessMsg(
                    'splitScreen.components.contextMenu.wasStarted',
                    { name: trainingNode.name }
                );
            })
        );
    }

    stop(trainingNode: TrainingTreeNode): Observable<void> {
        const url = `${this.baseUrl}/${trainingNode.uuid}`;
        return this.http.delete<void>(url).pipe(
            catchError((error) => {
                this.toastMessageService.showTranslatedErrorMsg(
                    'splitScreen.components.contextMenu.notStopped',
                    { name: trainingNode.name }
                );
                return throwError(() => error);
            }),
            tap(() => {
                this.toastMessageService.showTranslatedSuccessMsg(
                    'splitScreen.components.contextMenu.wasStopped',
                    { name: trainingNode.name }
                );
            })
        );
    }
}
